import browser from "webextension-polyfill";
import { matchingElementFoundKey, ytHavenEmbeddedPlayerIssue, ytHavenMetaTagFound, ytHavenNonEmbeddableFound, ytHavenNonPlayableFound, } from "../shared/index.js";
import { getIframePlayer, getToggleState, isInHavenExperiment, isWatchPage, videoContextStore, } from "./shared.js";
import { removeEmbedPlayer, removeInfoBox, start as startEmbedExperiment, } from "./embed-haven.js";
import { insertOverlayExp, removeVideoOverlay } from "./overlay.js";
import { startPause, resumeCurrentVideo, pauseCurrentVideos, } from "./pause-video.js";
const ytPlayerSelector = "ytd-player";
var PlayabilityStatus;
(function (PlayabilityStatus) {
    PlayabilityStatus["OK"] = "OK";
})(PlayabilityStatus || (PlayabilityStatus = {}));
const addExperiments = async () => {
    const targetElement = document.querySelector(ytPlayerSelector);
    if (!targetElement) {
        return;
    }
    await Promise.all([
        insertOverlayExp(targetElement),
        startEmbedExperiment(targetElement),
    ]);
};
const removeExperiments = () => {
    removeVideoOverlay();
    removeEmbedPlayer();
    removeInfoBox();
};
const navigationListener = async (event, toggleState = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    const videoId = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.endpoint) === null || _b === void 0 ? void 0 : _b.watchEndpoint) === null || _c === void 0 ? void 0 : _c.videoId;
    if (!isWatchPage() || !(await shouldStartExperiment()) || !videoId) {
        removeExperiments();
        return;
    }
    if (toggleState) {
        pauseCurrentVideos();
    }
    const playlistId = (_f = (_e = (_d = event === null || event === void 0 ? void 0 : event.detail) === null || _d === void 0 ? void 0 : _d.endpoint) === null || _e === void 0 ? void 0 : _e.watchEndpoint) === null || _f === void 0 ? void 0 : _f.playlistId;
    const isEmbeddable = (_k = (_j = (_h = (_g = event === null || event === void 0 ? void 0 : event.detail) === null || _g === void 0 ? void 0 : _g.response) === null || _h === void 0 ? void 0 : _h.playerResponse) === null || _j === void 0 ? void 0 : _j.playabilityStatus) === null || _k === void 0 ? void 0 : _k.playableInEmbed;
    const playabilityStatus = (_p = (_o = (_m = (_l = event === null || event === void 0 ? void 0 : event.detail) === null || _l === void 0 ? void 0 : _l.response) === null || _m === void 0 ? void 0 : _m.playerResponse) === null || _o === void 0 ? void 0 : _o.playabilityStatus) === null || _p === void 0 ? void 0 : _p.status;
    if (!isEmbeddable || playabilityStatus !== PlayabilityStatus.OK) {
        resumeCurrentVideo();
        removeExperiments();
        void browser.runtime.sendMessage({
            type: !isEmbeddable ? ytHavenNonEmbeddableFound : ytHavenNonPlayableFound,
            errorCode: playabilityStatus,
        });
        return;
    }
    const nextVideoId = (_z = (_y = (_x = (_w = (_v = (_u = (_t = (_s = (_r = (_q = event === null || event === void 0 ? void 0 : event.detail) === null || _q === void 0 ? void 0 : _q.response) === null || _r === void 0 ? void 0 : _r.response) === null || _s === void 0 ? void 0 : _s.contents) === null || _t === void 0 ? void 0 : _t.twoColumnWatchNextResults) === null || _u === void 0 ? void 0 : _u.autoplay) === null || _v === void 0 ? void 0 : _v.autoplay) === null || _w === void 0 ? void 0 : _w.sets[0]) === null || _x === void 0 ? void 0 : _x.autoplayVideo) === null || _y === void 0 ? void 0 : _y.watchEndpoint) === null || _z === void 0 ? void 0 : _z.videoId;
    const startSeconds = (_3 = (_2 = (_1 = (_0 = event === null || event === void 0 ? void 0 : event.detail) === null || _0 === void 0 ? void 0 : _0.response) === null || _1 === void 0 ? void 0 : _1.endpoint) === null || _2 === void 0 ? void 0 : _2.watchEndpoint) === null || _3 === void 0 ? void 0 : _3.startTimeSeconds;
    videoContextStore.setVideoContext({
        playlistId,
        isEmbeddable,
        videoId,
        nextVideoId,
        startSeconds,
    });
    await addExperiments();
};
const havenElementExits = () => {
    let metaTag = document.getElementById("yt-haven");
    if (metaTag) {
        return true;
    }
    metaTag = document.createElement("meta");
    metaTag.id = "yt-haven";
    (document.head || document.documentElement).prepend(metaTag);
    return false;
};
const iFrameErrorListener = (event) => {
    var _a, _b;
    const playerElem = getIframePlayer();
    if (playerElem &&
        playerElem instanceof HTMLIFrameElement &&
        event.source === playerElem.contentWindow &&
        "data" in event &&
        typeof event.data === "string") {
        const eventData = JSON.parse(event.data);
        const errorCode = (_b = (_a = eventData === null || eventData === void 0 ? void 0 : eventData.info) === null || _a === void 0 ? void 0 : _a.videoData) === null || _b === void 0 ? void 0 : _b.errorCode;
        if ((eventData === null || eventData === void 0 ? void 0 : eventData.event) === "initialDelivery" && errorCode) {
            void browser.runtime.sendMessage({
                type: ytHavenEmbeddedPlayerIssue,
                errorCode,
            });
        }
    }
};
const shouldStartExperiment = async () => {
    const matchingElementFound = await browser.storage.local.get(matchingElementFoundKey);
    return ((await isInHavenExperiment()) &&
        typeof matchingElementFound[matchingElementFoundKey] !== "undefined");
};
export async function start() {
    const [shouldStartExp, toggleState] = await Promise.all([
        shouldStartExperiment(),
        getToggleState(),
    ]);
    if (!shouldStartExp) {
        return;
    }
    if (havenElementExits()) {
        void browser.runtime.sendMessage({
            type: ytHavenMetaTagFound,
        });
        return;
    }
    if (toggleState) {
        startPause();
    }
    window.addEventListener("yt-navigate-finish", (event) => {
        void navigationListener(event, Boolean(toggleState));
    });
    window.addEventListener("message", (event) => {
        iFrameErrorListener(event);
    });
}
